export default {
    basicData: "basicData",
    purchaserData: "purchaserData",
    realizationType: "realizationType",
    documentsAccess: "documentsAccess",
    orderObject: "orderObject",
    qualification: "qualification",
    objectiveEvidence: "objectiveEvidence",
    orderTerms: "orderTerms",
    contractDraft: "contractDraft",
    orderDetails: "orderDetails",
    additionalInfo: "additionalInfo"
}

export const tenderResultNoticeStepsOrder = ["basicData", "purchaserData", "realizationType", "orderObject", "tenderCompletionData",
    "offersData", "contractorData", "contractData", "additionalInfo"];